import { AHIcon, TouchableBox } from "arkh";
import Animated, {
  SharedValue,
  useAnimatedStyle,
  useDerivedValue,
} from "react-native-reanimated";
import React, { useCallback, useMemo } from "react";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";

import { EmptyPositionT } from "./EmptyPosType";
import { useWidgetMargin } from "../Widget/useWidgetMargin";

const styles = StyleSheet.create({
  buttonWrapper: {
    borderWidth: 1,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});

function EmptyPositionC(props: {
  positions: SharedValue<EmptyPositionT[]>;
  positionIndex: number;
  unitSize: number;
  spaceBetweenColumns: number;
  onPress: (pos: EmptyPositionT) => void;
  children?: React.ReactNode;
  contentStyle?: StyleProp<ViewStyle>;
  disabled?: boolean;
}) {
  const margin = useWidgetMargin();

  const baseStyle = useMemo<StyleProp<ViewStyle>>(
    () => ({
      position: "absolute",
      padding: margin,
      overflow: "hidden",

      left: 0,
      top: 0,
    }),
    [margin]
  );

  const x = useDerivedValue(() => props.positions.value[props.positionIndex].x);
  const y = useDerivedValue(() => props.positions.value[props.positionIndex].y);
  const h = useDerivedValue(() => props.positions.value[props.positionIndex].h);
  const w = useDerivedValue(() => props.positions.value[props.positionIndex].w);
  const c = useDerivedValue(() => props.positions.value[props.positionIndex].c);
  const active = useDerivedValue(
    () => props.positions.value[props.positionIndex].active
  );

  const style = useAnimatedStyle(() => {
    if (!active.value) {
      return {
        transform: [{ scale: 0 }],
        display: "none",
        opacity: 0,
      };
    }
    return {
      width: props.unitSize * w.value,
      height: props.unitSize * h.value,
      display: "flex",
      opacity: 1,
      transform: [
        { scale: 1 },
        {
          translateX:
            (c.value + 0.5) * props.spaceBetweenColumns +
            c.value * props.unitSize * 2 +
            x.value * props.unitSize,
        },
        { translateY: y.value * props.unitSize },
      ],
    };
  });

  const onPress = useCallback(
    () => props.onPress(props.positions.value[props.positionIndex]),
    [props]
  );

  return (
    <Animated.View style={[baseStyle, style]}>
      <TouchableBox
        onPress={onPress}
        style={[styles.buttonWrapper, props.contentStyle]}
        borderColor="border-primary"
        cornerRadius="medium"
        disabled={props.disabled}
      >
        {props.children ?? <AHIcon type="add" color="primary" />}
      </TouchableBox>
    </Animated.View>
  );
}

export const EmptyPosition = React.memo(EmptyPositionC);
